import * as r3 from '@leandredev/r3-ng-lib';

import { ApiHelper, ConfService } from '@leandredev/common_ng';
import { map, switchMap } from 'node_modules/rxjs/operators';

import { DataService } from 'src/app/webservices/dataService.service';
import { Injectable } from '@angular/core';
import { Observable } from 'node_modules/rxjs';
import { interfaces } from '@leandredev/r3-common-lib';

@Injectable()
export class LoginService {
  public authService: r3.service.Authentication;

  constructor(private runTimeDataService: DataService, private confService: ConfService) {
    this.authService = this.runTimeDataService.authService;
  }
  signUp(userInfo: interfaces.ICreateProfileRequest): Observable<any> {
    // TODO : Supprimer le internalLogout une fois qu'on aura mis en place les boutons de logout
    // et les redirections auto pour un user déjà loggé
    // this.confService.internalLogout();
    return this.authService.signUp(userInfo, {}).pipe(
      ApiHelper.resultToObjWEmptyError('Error when sign up'),
      map(() => {
        return this.signIn({ login: userInfo.email, password: userInfo.password } as interfaces.ISigninRequest);
      })
    );
  }

  signInByLogin(email: string, password: string): Observable<any> {
    const siginRequest: interfaces.ISigninRequest = { login: email, password };
    return this.signIn(siginRequest);
  }

  private signIn(signinRequest: interfaces.ISigninRequest): Observable<any> {
    // TODO : Supprimer le internalLogout une fois qu'on aura mis en place les boutons de logout
    // et les redirections auto pour un user déjà loggé
    // this.confService.internalLogout(undefined);
    return this.authService.signIn(signinRequest, {}).pipe(
      ApiHelper.resultToObjWEmptyError('Error when sign in'),
      switchMap((res) => {
        return this.confService.connect(res.id_token);
      })
    );
  }

  signOut(): void {
    this.confService.internalLogout();
  }
  isSignedIn(): boolean {
    return this.confService.connected;
  }
  lostPassword(email: string, url: string): Observable<any> {
    return this.authService.lostPassword({ email, redirectUrl: url }, {});
  }

  reserPassword(resetPasswordRequest: interfaces.IresetPasswordRequest): Observable<any> {
    return this.authService.resetPassword(resetPasswordRequest, {}).pipe(ApiHelper.resultToObjWEmptyError('Erreur de mise a jour du mot de passe'));
  }
}
